import { Chip, Tooltip } from "@mui/material";
import { PolicyOrAccount, Product, ProductType, AdjustedProductType } from "../../../interfaces/DTO/mislaka_xml_models";
import { PolicyEmploymentStatus } from "../../../interfaces/DTO/mislaka_xml_pension_models";

interface Props {
  policies: PolicyOrAccount[];
  product: Product;
}

export const Tikun190Chip = ({ policies, product }: Props) => {
  // בדיקה אם המוצר הוא קופת גמל
  const isProvidentFund =
    product.details?.product_type === ProductType.PROVIDENT_FUND;
  // בדיקה אם יש תיקון 190
  const hasTikun190 = policies.some(
    (p) => p.pension_data?.tikun_190_option === 1
  );
  // בדיקה אם הסטטוס התעסוקתי הוא שכיר
  const isSalaried = policies.some(
    (p) => p.plan_or_account_type === PolicyEmploymentStatus.EMPLOYEE
  );

  // הצג רק אם זה קופת גמל, יש תיקון 190, והסטטוס אינו שכיר
  if (!isProvidentFund || !hasTikun190 || isSalaried) {
    return null;
  }

  return (
    <Tooltip title="תיקון 190" arrow placement="top">
      <Chip
        label="תיקון 190"
        sx={{
          cursor: "pointer",
          fontSize: "0.875rem",
          backgroundColor: "#9C27B0",
          color: "white",
        }}
      />
    </Tooltip>
  );
};
